import React from "react";
import Cart from "../Components/Cart/Cart";
import NavBar from "../Components/NavBar/NavBar";
function CartPage(props) {
  return (
    <>
      <NavBar />
      <Cart />
    </>
  );
}

export default CartPage;
